/**
 * Checks window.gtag is enable
 *
 * @returns {boolean}
 */
const isEnableGtag = () => !!window.gtag;

export default isEnableGtag;
